import React from "react";
import "./MainFile.scss";
import executiveSummary from "../../data/DownloadTable";

const MainFile = () => {
  return (
    <div id="main-download-file">
      <div className="exec-summary-cont">
        <table className="exec-summary-table">
          <thead>
            <tr>
              <th style={{ width: "33.33%", borderRadius: "10px 0px 0px 0px" }}>
                QMS Results (Full Audit or Addendum)
              </th>
              <th style={{ width: "33.33%", borderRadius: "0px 10px 0px 0px" }}>
                Number of non-conformances
              </th>
              <th style={{ width: "33.33%", borderRadius: "0px 10px 0px 0px" }}>
                Non-Conformance Points
              </th>
            </tr>
          </thead>
          <tbody>
            {executiveSummary.map((row, index) => (
              <tr key={row.id}>
                <td>{row.qmsResult}</td>
                <td>{row.nonComformance}</td>
                <td>{row.nonComfPoint}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MainFile;
